import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  AladinSkyLayersSliderComponent
} from './aladin-layers/aladin-sky-layers-slider/aladin-sky-layers-slider.component';
import {AladinContainerComponent} from './aladin-container/aladin-container.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {AladinSkyComponent} from './aladin-sky/aladin-sky.component';
import {
  AladinPopoverContainerComponent
} from './aladin-popover/aladin-popover-container/aladin-popover-container.component';
import {
  AladinPopoverFootprintComponent
} from './aladin-popover/aladin-popover-footprint/aladin-popover-footprint.component';
import {
  AladinPopoverSkyObjectComponent
} from './aladin-popover/aladin-popover-sky-object/aladin-popover-sky-object.component';
import {
  AladinPopoverContextmenuComponent
} from './aladin-popover/aladin-popover-contextmenu/aladin-popover-contextmenu.component';
import {AsaxCommonModule} from 'asax-common';
import {NgxDatatableModule} from '@almaobservatory/ngx-datatable';
import {AladinConfigurationComponent} from './aladin-configuration/aladin-configuration.component';
import {
  AladinSkyLayersOptionsComponent
} from "./aladin-layers/aladin-sky-layers-options/aladin-sky-layers-options.component";
import {
  AladinSkyLayersContainerComponent
} from './aladin-layers/aladin-sky-layers-container/aladin-sky-layers-container.component';
import {
  AladinSkyLayersProgressComponent
} from './aladin-layers/aladin-sky-layers-progress/aladin-sky-layers-progress.component';
import { AladinVoComponent } from './aladin-vo/aladin-vo.component';
import { AladinPopoverSearchRadiusComponent } from './aladin-popover/aladin-popover-search-radius/aladin-popover-search-radius.component';


@NgModule({
  declarations: [
    AladinSkyLayersSliderComponent,
    AladinContainerComponent,
    AladinSkyLayersOptionsComponent,
    AladinSkyComponent,
    AladinPopoverContainerComponent,
    AladinPopoverFootprintComponent,
    AladinPopoverSearchRadiusComponent,
    AladinPopoverSkyObjectComponent,
    AladinPopoverContextmenuComponent,
    AladinConfigurationComponent,
    AladinSkyLayersContainerComponent,
    AladinSkyLayersProgressComponent,
    AladinVoComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    AsaxCommonModule,
    NgxDatatableModule
  ],
  exports: [
    AladinContainerComponent
  ]
})
export class AladinModule {
}
